// Pasted text -> checklist steps: one step per line, as a Trello card's
// checklist is copied. List markers and empty lines are dropped.
const LIST_MARKER = /^\s*(?:[-*•]|\[[ xX]?\]|\d+[.)])\s+/;

export const parseChecklistSteps = (text: string): string[] =>
  text
    .split(/\r?\n/)
    .map((line) => line.replace(LIST_MARKER, "").trim())
    .filter((line) => line.length > 0);
